import type { QueryClient } from '@tanstack/react-query'

import { COMMUNITY_LIFETIME } from '../models/community.constants'
import { getActiveJourneySubscriptionsOptions } from '../services/useActiveJourneySubscriptionsQuery'
import { getQueryCommunitySubscriptionOptions } from '../services/useCommunitySubscriptionsQuery'
import { getEverlastingSubscriptionsOptions } from '../services/useEverlastingSubscriptionsQuery'

export const invalidateSubscriptionQueries = (
  queryClient: QueryClient,
  { id, lifetime, hasJoined }: { id: number; lifetime: COMMUNITY_LIFETIME | undefined; hasJoined: boolean | undefined },
) => {
  const queries = []
  if (id && lifetime) queries.push(getQueryCommunitySubscriptionOptions({ id, lifetime }))
  if (hasJoined || hasJoined === undefined) {
    if (lifetime !== COMMUNITY_LIFETIME.EVERLASTING) queries.push(getActiveJourneySubscriptionsOptions())
    if (!lifetime || lifetime === COMMUNITY_LIFETIME.EVERLASTING) queries.push(getEverlastingSubscriptionsOptions())
  }
  return Promise.all(queries.map((query) => queryClient.invalidateQueries(query)))
}
